module.exports = __webpack_public_path__ + "static/media/MTL_BASE_SL3.16606384.png";